import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const CalendarSettingModalWrap = styled.section`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  z-index: 99999;
`;

export const PurchasedModalContents = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: fit-content;
  background-color: ${themes.colors.white};
  border: 1px solid ${themes.colors.border};
  border-radius: 8px;
  z-index: 10;
  width: 90%;
  @media ${device.desktop} {
    width: 80%;
    height: 600px;
    max-width: 1000px;
  }
`;

export const ContentsWrap = styled.div`
  margin: 0 20px;
  height: inherit;
  display: flex;
  flex-flow: column;
  justify-content: center;
  @media ${device.tablet} {
    margin: 0 40px;
  }
  @media ${device.desktop} {
    margin: 0 80px;
  }
`;

export const SelectedNameWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const SelectedNameLabel = styled.h3`
  font-size: ${themes.textSize.m3};
  @media ${device.tablet} {
    font-size: ${themes.textSize.m3};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l1};
  }
`;

export const SelectedGBLabel = styled.h3`
  font-size: ${themes.textSize.m3};
  margin-left: 20px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m3};
    margin-left: 25px;
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l1};
    margin-left: 30px;
  }
`;

export const SelectedSpecWrap = styled.div`
  display: block;
`;

export const SelectedSpecItem = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  border-bottom: 1px solid ${themes.colors.border};
  margin: 10px 0;
  padding: 10px;
  @media ${device.tablet} {
    flex-wrap: wrap;
    font-size: ${themes.textSize.l1};
    margin: 20px 0;
    padding: 20px;
    height: 50px;
  }

  @media ${device.desktop} {
  }
`;

export const PurchasedRequest = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 6px;
  padding: 6px;
  color: ${themes.colors.white};
  border-radius: 10px;
  width: 100%;
  cursor: pointer;
  background-color: ${themes.colors.filled};
  white-space: nowrap;
  text-align: center;
  height: 30px;
  font-size: ${themes.textSize.s3};
  max-width: 120px;
  font-weight: bold;
  @media ${device.tablet} {
    height: fit-content;
    margin: 10px 10px 20px;
    padding: 10px;
    font-size: ${themes.textSize.m1};
    max-width: 150px;
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.m2};
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const PriceLabelWrap = styled.div`
  @media ${device.tablet} {
  }
`;

export const SpecLabel = styled.label`
  display: block;
  color: ${themes.colors.text};
  font-size: ${themes.textSize.s3};
  font-weight: bold;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.m2};
  }
`;

export const PriceLabel = styled.label`
  display: block;
  color: ${themes.colors.filled};
  font-size: ${themes.textSize.m2};
  font-weight: bold;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m2};
  }
`;
export const DoubleLinePriceLabel = styled.label`
  display: block;
  color: ${themes.colors.text};
  font-size: ${themes.textSize.m1};
  text-decoration: line-through;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m2};
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  border: 1px solid ${themes.colors.text};
  border-radius: 50%;
  background: none;
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CloseButton = styled.img`
  width: 30px;
  color: ${themes.colors.border};
  @media ${device.tablet} {
  }
`;
